module.exports = __webpack_public_path__ + "img/distribution.5501d594.jpg";